<template>
<div style="display: flex;">
    <el-form label-position="right" label-width="100px" :model="formData" class="pr_20" :style="{ width: formData.logs && formData.logs.length ? '70%' : '100%' }">
        <!-- <el-form-item label="录单员工：" v-if="formData.id">
            {{formData.admin.nick_name}} {{formData.admin.phone}}
        </el-form-item> -->
        <div style="display: flex;">
            <el-form-item label="订单商品：">
                <el-radio-group v-model="formData.good_type" @input="goodTypeInput">
                    <el-radio :label="1">标准商品</el-radio>
                    <el-radio :label="4">定制商品</el-radio>
                    <el-radio :label="5">礼品</el-radio> 
                    <el-radio :label="6">赠品</el-radio> 
                </el-radio-group>
            </el-form-item>
            <div style="margin-left: auto;">
                <el-form-item label="订单状态：" v-if="formData.id">
                    {{formData.state_text}}
                </el-form-item>
            </div>
        </div>
        <el-form-item label="订单客户：">
            <span style="margin-right: 20px;">{{user.name}} {{user.phone}}</span>
        </el-form-item>
        <el-row>
          <el-col :span="12">
              <el-form-item label="收货人：">
                  <el-input placeholder="" v-model="formData.receive_name" clearable :disabled="noedit"/>
              </el-form-item>
          </el-col>
          <el-col :span="12">
              <el-form-item label="收货电话：">
                  <el-input placeholder="" v-model="formData.receive_phone" clearable :disabled="noedit"/>
              </el-form-item>
          </el-col>
        </el-row>
        <div class="yellow" style="padding-left: 120px;">该用户非黑名单，无近七天撞单入单限制（该客户有历史单时，则不允许下单)</div>
        <el-form-item label="收货地址：">
            <div class="_flex">
                <el-cascader v-model="formData.region" :key="cascaderKey" clearable :props="regionprops" :disabled="noedit" style="width: 500px;"></el-cascader>
                <el-button v-if="formData.receive_address && !formData.region[0]" size="mini" style="margin-left: 10px;" :loading="parseLoading" @click="getParseAddress(formData.receive_address)">解析地址</el-button>
            </div>
        </el-form-item>
        <el-form-item label=" ">
            <el-input v-model="formData.receive_address" clearable placeholder="详细地址" :disabled="noedit"/>
        </el-form-item>
        <img src="@/assets/new/line.jpg" alt="" style="width: 100%;"/>
    
        <el-table :data="formData.goods" >
            <el-table-column prop="good_name_full" label="商品" min-width="300"></el-table-column>
            <el-table-column prop="spec_data_str" label="规格" width="200"></el-table-column>
            <el-table-column prop="sale_price" label="单价" width="100"></el-table-column>
            <el-table-column prop="quatity" label="数量" width="200">
                <template v-slot="{row}">
                    <el-input-number v-model="row.quatity" size="mini" controls-position="right" :min="1" :max="999" :step="1" step-strictly :disabled="noedit"></el-input-number>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="操作" width="80">
                <template v-slot="{row}">
                    <i v-if="!noedit" class="el-icon-delete red f_18" style="cursor: pointer;" @click="removeGood(row)"></i>
                </template>
            </el-table-column>
        </el-table>
    
        <div class="mt_10 mb_20 _flex_sb _f_ai">
            <div class="_button bag_green" @click="goodsShow=true" v-if="!noedit">添加商品</div>
            <div class="">
            共计：商品 <span style="color: red;margin-right: 10px;">{{formData.goods ? formData.goods.length : 0}}</span>
            金额 <span style="color: red;margin-right: 10px;">{{goodAmount}}</span>
            </div>
        </div>
        <el-form-item label="加价金额：">
            <el-input placeholder="" v-model.number="formData.add_amount" clearable :disabled="noedit" style="width: 300px;"/>
        </el-form-item>
        <el-form-item label="优惠金额：">
            <el-input placeholder="" v-model.number="formData.reduce_amount" clearable :disabled="noedit" style="width: 300px;"/>
        </el-form-item>
        <el-form-item label="支付方式：">
            <el-radio-group class="_flex _f_ai" v-model="formData.pay_type" :disabled="noedit">
                <el-radio :label="1">预付定金</el-radio>
                <el-input placeholder="定金金额" v-model="formData.pre_money" clearable :disabled="noedit" style="width: 120px;margin-right: 20px;"/>
                <el-radio :label="2">预付全款</el-radio>
                <el-radio :label="3">到货付款</el-radio>
                <el-radio :label="4">售后补货</el-radio> 
              </el-radio-group>
        </el-form-item>
        <el-form-item label="快递方式：">
            <el-radio-group v-model="formData.deliver_type" :disabled="noedit">
                <el-radio :label="1">快递配送</el-radio>
                <el-radio :label="2">用户自提</el-radio> 
            </el-radio-group>
        </el-form-item>
        <el-form-item label="物流快递：">
            <el-select v-model="formData.express_type" placeholder="" :disabled="noedit" class="mr_5">
                <el-option :label="item.name" :value="item.id" v-for="item in logistics" :key="item.id"></el-option>
                <el-option label="其他" :value="0"></el-option>
            </el-select>
            <span style="margin-left: 10px;" v-if="formData.express_type > 0">京东快递：</span>
            <el-radio-group v-model="formData.jd_product_code" v-if="formData.express_type > 0">
                <el-radio v-for="item in productCodeArr" :key="item.code" :label="item.code">{{item.name}}</el-radio>
            </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="保费金额：" v-if="formData.deliver_type == 1 && formData.express_type">
            <div class="_flex _f_ai">
                <el-input placeholder="" v-model="formData.insured_money" :disabled="noedit" style="width: 200px;"/>
                <div class="c9">（保费:保价=1元:500元）</div>
            </div>
        </el-form-item> -->
        <el-form-item label="内部备注：">
            <div class="_flex _f_ai">
                <el-input placeholder="" v-model="formData.remark" :disabled="noedit" style="width: 500px;"/>
                <div class="c9">（不上面单）</div>
            </div>
        </el-form-item>
        <el-form-item label="合计金额：">
            <div class="red f_12" v-if="formData.pay_type == 4">￥<span class="f_22">0</span></div>
            <div class="red f_12" v-else>￥<span class="f_22">{{payAmount}}</span></div>
        </el-form-item>
        <div v-if="!formData.id || (formData.can_edit && checkAuth('/admin/crm/orderEdit') && !formData.can_check && !formData.can_pay && !formData.can_send) && formData.state < 40" style="display: flex;justify-content: center;align-items: center;">
            <div class="mr_20">
                <span class="red">订单处理：</span>
                <el-radio-group v-model="formData.submit_state">
                    <el-radio :label="10">提交审核</el-radio>
                    <el-radio :label="-10">存入草稿</el-radio> 
                </el-radio-group>
            </div>
            <div>
                <el-button type="primary" @click="submit" v-loading="loading">确 定</el-button>
                <el-button type="danger" v-if="formData.id" @click="cancel">取消订单</el-button>
                <el-button @click="close">取 消</el-button>
            </div>
        </div>
        <div v-if="formData.id" style="display: flex;justify-content: space-around;">
            <div v-if="formData.can_check && checkAuth('/admin/crm/orderCheck')">
                <el-button @click="sms">发送短息</el-button>
                <el-button type="primary" @click="submit">保存</el-button>
                <el-button type="success" @click="check(30)">审核通过</el-button>
                <el-button type="warning" @click="check(20)">审核拒绝</el-button>
                <el-button @click="close">取 消</el-button>
            </div>
            <div v-if="formData.can_pay && checkAuth('/admin/crm/orderPay')">
                <el-button type="primary" @click="submit">保存</el-button>
                <el-button type="success" @click="pay" v-loading="loading">订单确认并单据</el-button>
                <el-button type="warning" @click="check(20)">审核拒绝</el-button>
                <el-button @click="close">取 消</el-button>
            </div>
            <div v-if="formData.can_send && checkAuth('/admin/crm/orderSend')">
                <el-select v-model="formData.express_sn" v-if="formData.express_type == 0" style="width: 150px;" placeholder="物流公司" @visible-change="getExpress">
                    <el-option v-for="(item,index) in expressArr" :key="index" :label="item.express_name" :value="item.express_sn"></el-option>
                </el-select>
                <el-input placeholder="物流单号" v-model="formData.express_no" v-if="formData.express_type == 0" style="width: 180px;margin: 0 10px;" />
                <el-button type="success" @click="send(0)" v-if="formData.express_type == 0" v-loading="loading">物流确认</el-button>
                <el-button type="danger" @click="send(1)" v-if="formData.express_type > 0" v-loading="jdloading">京东仓发货</el-button>
                <!-- <el-button type="primary" @click="submit">保存</el-button> -->
                <el-button type="warning" @click="check(20)">审核拒绝</el-button>
                <el-button @click="close">取 消</el-button>
            </div>
            <!-- <div v-if="formData.can_shiping_edit">
                <el-button type="primary" @click="submit">保存</el-button>
                <el-button @click="close">取 消</el-button>
            </div> -->
            <div v-else-if="shouldShowSuperAdminButtons" style="text-align: center; width: 100%; margin-top: 20px;">
                <el-button type="primary" @click="submit">保存</el-button>
                <el-button @click="close">取 消</el-button>
            </div>
        </div>
    
        <el-dialog title="选择商品" :visible="goodsShow" width="80%" center append-to-body @close="goodsShow=false">
            <GoodSelect v-model="formData.goods" v-if="goodsShow" :good_type="formData.good_type" :show_cost="false" @input="goodChange" @close="goodsShow=false"></GoodSelect>
        </el-dialog>
    </el-form>
    <div v-if="formData.logs && formData.logs.length" style="border-left: 1px solid #eee;width: 30%;padding: 10px;display: flex;flex-direction: column;">
        <div style="padding: 0 0 20px 40px;">订单历史</div>
        <el-timeline>
            <el-timeline-item v-for="(log, index) in formData.logs" :key="index">
                <div><span class="_color">{{log.type_text}}：</span> {{log.admin.admin_id ? log.admin.nick_name : ''}} {{log.admin.admin_id ? log.admin.phone.slice(-4) : ''}}</div>
                <div style="margin: 10px 0 0 20px;" v-if="log.type == 8 || log.type == 14">{{log.content}}</div>
                <div style="margin: 10px 0 0 20px;">{{log.created_time}}</div>
            </el-timeline-item>
        </el-timeline>
    </div>

    <Smssend :visible.sync="smsVisible" :userArr="selectedUsers" @close="smsVisible = false" />
</div>
</template>

<script>
import GoodSelect from "@/components/select/GoodSelect.vue"
import Smssend from "@/components/crm/Smssend.vue"

import http from '@/request/http.js'
import base from '@/request/base.js'
import { crmorderAdd, crmorderDetail, crmorderEdit, crmorderShipingEdit, region, express, crmorderCheck, crmorderPay, crmorderSend, setJd, parseAddress, crmorderCancel } from "@/request/apis.js";

export default {
    name: 'CrmOrder',
    components: {
        GoodSelect, Smssend
    },
    props: {
        user: {
            type: Object,
            default: () => {}
        },
        order_id: {
            type: [Number, String],
            default: 0
        },
        action: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            search: {
                nick_name: '',
                phone: '',
                depart_id: 0,
                page: 1,
                limit: 10,
                total: 0,
            },
            type: 1,
            goodsShow: false,
            formDataInit: {
                good_type: 1,
                user_id: '',
                receive_name: '',
                receive_phone: '',
                region: [],
                receive_province_id: '',
                receive_city_id: '',
                receive_area_id: '',
                receive_street_id: '',
                receive_address: '',
                goods: [],
                add_amount: '',
                reduce_amount: '',
                pay_type: '',
                pre_money: '',
                deliver_type: 1,
                express_type: '',
                insured_money: 1,
                remark: '',
                state: 10,
                submit_state: 10,
            },
            formData: {},
            regionprops: {
                checkStrictly: true,
                lazy: true,
                lazyLoad: this.lazyLoadRegion,
            },
            expressArr: [],
            smsVisible: false,
            selectedUsers: [],
            loading: false,
            jdloading: false,
            logistics: [],
            productCodeArr: [],
            cascaderKey: 0,
            parseLoading: false,
        }
    },
    mounted() {
        console.log('crmorder component mounted');
        this.init();
    },
    activated() {
        console.log('crmorder component console');
        this.init();
    },
    computed: {
        goodAmount() {
            let total = 0;
            if(this.formData.goods){
                this.formData.goods.forEach(element => {
                    total += element.sale_price * (element.quatity || 0);
                });
            }
            return total.toFixed(2);
        },
        payAmount() {
            return (parseFloat(this.goodAmount) + parseFloat(this.formData.add_amount || 0) - parseFloat(this.formData.reduce_amount || 0)).toFixed(2);
        },
        isSuperAdmin() {
            const loginInfo = JSON.parse(localStorage.getItem('loginInfo') || '{}');
            return loginInfo.admin_id === 1;
        },
        noedit(){
            if (this.isSuperAdmin) {
                return false;
            }
            return this.formData.id && this.formData.state > 30;
        },
        // 判断保存按钮是否已经显示
        isSaveButtonVisible() {
            if (!this.formData.id) {
                return false;
            }
            
            // 检查是否处于任何业务流程状态
            const isCheckState = this.formData.can_check && this.checkAuth('/admin/crm/orderCheck');
            const isPayState = this.formData.can_pay && this.checkAuth('/admin/crm/orderPay');
            const isSendState = this.formData.can_send && this.checkAuth('/admin/crm/orderSend');
            
            // 如果处于任何业务流程状态，则保存按钮已经显示
            return isCheckState || isPayState || isSendState;
        },
        // 判断是否应该显示超级管理员的通用按钮
        shouldShowSuperAdminButtons() {
            // 只有超级管理员且保存按钮未显示时才显示
            return this.isSuperAdmin && this.formData.id && !this.isSaveButtonVisible;
        }
    },
    methods: {
        async init() {
            this.formData = JSON.parse(JSON.stringify(this.formDataInit));
            this.formData.submit_state = 10;
            
            if(this.order_id){
                await this.getOrderDetail(this.order_id);
            } else if(this.user && this.user.id){
                this.formData.user_id = this.user.id;
                this.formData.receive_name = this.user.name;
                this.formData.receive_phone = this.user.phone;
                this.formData.receive_province_id = this.user.province;
                this.formData.receive_city_id = this.user.city;
                this.formData.receive_area_id = this.user.area;
                this.formData.receive_street_id = this.user.street;
                this.formData.receive_address = this.user.address;
                this.formData.region = [this.formData.receive_province_id, this.formData.receive_city_id, this.formData.receive_area_id, this.formData.receive_street_id];
            }
            this.formData.region = this.formData.region.filter(item => item);
            console.log('order init', this.formData)
            this.cascaderKey += 1;
            this.getSetJd();
        },
        async getSetJd(){
            let res = await http({ url: `${base.domain}/admin/setting/jd?from=crmorder`, method: 'get'});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.logistics = res.data.jd_accounts.filter(item => item.state == 1);
            this.productCodeArr = res.data.product_code;
        },
        goodChange(goods) {
            console.log('goodchange', goods);
            this.formData.goods = [];
            this.$nextTick(() => {
                let warehouse_id = 0;
                let warehouse_error = 0;
                this.formData.goods = goods.map(item => {
                    item.good_name_full = item.good_name;
                    if(item.package.length){
                        item.good_name_full += '（' + item.package.map(p => (p.good_name + ' x ' + p.quatity)).join(' + ') +'）';
                    }
                    if(item.warehouse_id){
                        if(!warehouse_id){
                            warehouse_id = item.warehouse_id;
                        }else if(warehouse_id != item.warehouse_id){
                            warehouse_error = 1;
                        }
                    }
                    this.$set(item, 'quatity', 1);
                    return item;
                });
                console.log('goodChange', warehouse_id)
                if(warehouse_error){
                    return this.$message.error('商品的发货仓库不一致');
                }else if(warehouse_id){
                    this.formData.express_type = warehouse_id;
                    // 选择标准商品自动匹配 京东标快，选择礼品商品自动匹配电商标快
                    if(!this.formData.jd_product_code){
                        if(this.formData.good_type == 1){
                            this.formData.jd_product_code = 'ed-m-0001';
                        }else if(this.formData.good_type == 5 || this.formData.good_type == 6){
                            this.formData.jd_product_code = 'ed-m-0001';
                        }
                    }
                }
            });
        },
        removeGood(row){
            this.formData.goods = this.formData.goods.filter(item => item.sku_id != row.sku_id);
        },
        close(){
            this.$emit('close');
        },
        async submit(){
            if(this.loading){
                return this.$message.error('订单提交中,请勿重复提交');
            }
            try {
                this.loading = true;
                const api = this.formData.id ? (this.formData.can_shiping_edit ? crmorderShipingEdit : crmorderEdit) : crmorderAdd;
                const res = await api({...this.formData});
                if (res.code !== 0) {
                    this.$message.error(res.msg);
                    this.loading = false;
                    return;
                }
                
                this.$message.success(res.msg);
                this.loading = false;
                this.$emit('close');
            } catch (error) {
                this.$message.error('提交订单失败');
                console.error('提交订单失败:', error);
            }
        },
        async lazyLoadRegion(node, resolve) {
            const { level } = node;
            const parentId = node.value || 0;

            const res = await region({ pid: parentId });
            if (res.code !== 0) {
                return this.$message.error(res.msg);
            }
            const nodes = res.data.map(item => ({
                value: item.region_id,
                label: item.region_name,
                leaf: level >= 3
            }));
            resolve(nodes);
        },
        async getOrderDetail(id){
            try {
                const res = await crmorderDetail({id});
                if (res.code !== 0) {
                    return this.$message.error(res.msg);
                }
                this.formData = { ...this.formDataInit, ...res.data, };
            } catch (error) {
                this.$message.error('获取订单详情失败');
                console.error('获取订单详情失败:', error);
            }
        },
        async cancel(){
            var res = await crmorderCancel({ids: [this.formData.id]});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
            this.$emit('close');
        },
        async check(state){
            var res = await crmorderCheck({id: this.formData.id, check_state: state});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
            this.$emit('close');
        },
        sms(){
            this.selectedUsers = [this.user];
            this.smsVisible = true;
        },
        async pay(){
            this.loading = true;
            var res = await crmorderPay({id: this.formData.id});
            this.loading = false;
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
            this.$emit('close');
        },
        async getExpress(query){
            if(!query){
                return;
            }
            var res = await express();
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.expressArr = res.data;
        },
        async send(express_type){
            if(express_type == 0){
                this.loading = true;
            }else{
                this.jdloading = true;
            }
            var res = await crmorderSend({id: this.formData.id, express_sn: this.formData.express_sn, express_no: this.formData.express_no});
            if(express_type == 0){
                this.loading = false;
            }else{
                this.jdloading = false;
            }
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
            this.$emit('close');
        },
        async getParseAddress(){
            this.parseLoading = true;
            let res = await parseAddress({address: this.formData.receive_address});
            this.parseLoading = false;
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            if(!res.data.area){
                return this.$message.error('解析失败,请手动设置');
            }
            if(!res.data.street){
                this.$alert('无法解析街道,请手动设置街道和详细地址', '解析结果');
            }
            this.formData.receive_province_id = res.data.province;
            this.formData.receive_city_id = res.data.city;
            this.formData.receive_area_id = res.data.area;
            this.formData.receive_street_id = res.data.street;
            this.formData.receive_address = res.data.street ? res.data.detail : res.data.address;
            this.formData.region = [res.data.province,res.data.city,res.data.area,res.data.street];
            this.formData.region = this.formData.region.filter(item => item != 0);
            this.cascaderKey += 1;
        },
        goodTypeInput(val){
            if(this.formData.id){
                return;
            }
            if(val == 5 || val == 6){
                this.formData.pay_type = this.formData.pay_type ? this.formData.pay_type : 3;
                let lastCode = this.productCodeArr[this.productCodeArr.length - 1].code;
                lastCode = this.productCodeArr[0].code;
                this.formData.jd_product_code = this.formData.jd_product_code ? this.formData.jd_product_code : lastCode;
            }
        }
    },
}
</script>

<style scoped>

</style>